'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInstantsearchCore = require('react-instantsearch-core');

var _utils = require('../core/utils');

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = (0, _utils.createClassNames)('HierarchicalMenu');

var itemsPropType = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  label: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  count: _propTypes2.default.number.isRequired,
  items: function items() {
    return itemsPropType.apply(undefined, arguments);
  }
}));

var HierarchicalMenu = function (_Component) {
  _inherits(HierarchicalMenu, _Component);

  function HierarchicalMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HierarchicalMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HierarchicalMenu.__proto__ || Object.getPrototypeOf(HierarchicalMenu)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item) {
      var _this$props = _this.props,
          createURL = _this$props.createURL,
          refine = _this$props.refine;


      return _react2.default.createElement(
        _Link2.default,
        {
          className: cx('link'),
          onClick: function onClick() {
            return refine(item.value);
          },
          href: createURL(item.value)
        },
        _react2.default.createElement(
          'span',
          { className: cx('label') },
          item.label
        ),
        ' ',
        _react2.default.createElement(
          'span',
          { className: cx('count') },
          item.count
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HierarchicalMenu, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_List2.default, _extends({
        renderItem: this.renderItem,
        cx: cx
      }, (0, _pick3.default)(this.props, ['translate', 'items', 'showMore', 'limit', 'showMoreLimit', 'isEmpty', 'canRefine', 'className'])));
    }
  }]);

  return HierarchicalMenu;
}(_react.Component);

HierarchicalMenu.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  refine: _propTypes2.default.func.isRequired,
  createURL: _propTypes2.default.func.isRequired,
  canRefine: _propTypes2.default.bool.isRequired,
  items: itemsPropType,
  showMore: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  limit: _propTypes2.default.number,
  showMoreLimit: _propTypes2.default.number,
  transformItems: _propTypes2.default.func
};
HierarchicalMenu.defaultProps = {
  className: ''
};
exports.default = (0, _reactInstantsearchCore.translatable)({
  showMore: function showMore(extended) {
    return extended ? 'Show less' : 'Show more';
  }
})(HierarchicalMenu);


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/components/HierarchicalMenu.js
// module id = 1078
// module chunks = 142807904292071